module.exports = __webpack_public_path__ + "img/screenmirroring.85c60609.svg";